// eslint-disable-next-line import/no-anonymous-default-export
export default {
  loading: false,
  error: false,
  getTechnicianListStatus: { data: null },
  createTechniciansStatus: { data: null },
  resetPinStatus: { data: null },
  updateTechnicianStatusStatus: { data: null },
  updateTechnicianEarningStatusStatus: { data: null },
  getTechnicianStatus: { data: null },
  getcompanyListStatus: { data: null },
  deleteTechnicianStatus: { data: null },
  getTechnicianEarningListStatus: { data: null },
  deleteTechnicianEarningStatus: { data: null },
};
